<template>
    <div>
        <!-- User Interface controls -->
        <b-row>
            <b-col md="7" class="my-1">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Main table element -->
            <b-table small caption-top show-empty empty-text="Please wait while the competencies load."       striped responsive stacked="md" 
                 :items="items" 
                 :fields="fields" 
                 :current-page="currentPage" 
                 :per-page="perPage"
                  :filter="filter" 
                  :sort-by.sync="sortBy"
                 @filtered="onFiltered">
            <template v-slot:cell(competency)="row">
                {{ row.item.title }}
              <div>
                <small>{{ row.item.category }}</small>
              </div>
            </template>
            <template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button-group>
                    <b-button @click.stop="row.toggleDetails" class="btn btn-success">
                       Competency Details <span class="icon icon-info"></span>
                    </b-button>
                </b-button-group>                
            </template>
            <template v-slot:row-details="row">
                <b-card>
                  <div class="font-weight-bold mb-3">{{ row.item.title }}</div>
                  <table class="table table-striped bg-white">
                    <tbody>
                      <tr>
                        <td>
                          <span class="font-weight-bold">Task</span>
                        </td>
                        <td>
                          {{ row.item.task }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="font-weight-bold">Performance Objectives</span>
                        </td>
                        <td>
                          {{ row.item.objectives }}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="font-weight-bold">Directions to Candidate</span>
                        </td>
                        <td>
                          <div v-html="row.item.description"></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <hr>
                  <div class="font-weight-bold mb-3">Steps</div>
                  <table class="table table-striped bg-white">
                    <tbody>
                      <tr v-for="(step, index) in row.item.steps" :key="index">
                        <td>
                          {{ index + 1 }}
                        </td>
                        <td v-html="step"></td>
                      </tr>
                    </tbody>
                  </table>
                  <hr>
                  <div class="font-weight-bold mb-3">Considerations / Critical Inclusions</div>
                  <table class="table table-striped bg-white">
                    <tbody>
                      <tr v-for="(consideration, index) in row.item.considerations" :key="index">
                        <td>
                          {{ index + 1 }}
                        </td>
                        <td v-html="consideration"></td>
                      </tr>
                    </tbody>
                  </table>
                </b-card>
            </template>
        </b-table>

        <b-row>
            <b-col md="12" class="my-1">
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
            </b-col>
        </b-row>

    </div>
</template>

<script>
const items = [];
export default {
  props: ['competencies'],
  data() {
    return {
      items: this.competencies,
      fields: [
        { key: "competency", label: "Competency", sortable: true },
        { key: "actions", label: "Actions" }
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: this.competencies.length,
      pageOptions: [15, 25, 35, 50],
      filter: null,
      sortBy: null,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(f => f.sortable).map(f => {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<!-- table-complete-1.vue -->